import React from 'react';
import BackButtonCollapseDashProvider from 'context/dash/BackButtonCollapseDash';
import DetailVisibleProvider from 'context/dash/DetailVisible';
import ShowAllEventsProvider from 'context/dash/ShowAllEvents';
import DashContainer from 'modules/dashboard/_common/DashContainer';
import CampaignsPage from 'modules/dashboard/producer/campaigns/CampaignsPage';

export default function DashCampaigns() {
    return (
        <BackButtonCollapseDashProvider>
            <ShowAllEventsProvider>
                <DetailVisibleProvider>

                    <DashContainer title='Campanhas'>
                        <CampaignsPage />
                    </DashContainer>

                </DetailVisibleProvider>
            </ShowAllEventsProvider>
        </BackButtonCollapseDashProvider>
    );
}
